"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Context = void 0;
var _useContextSelector = require("use-context-selector");
var Context = (0, _useContextSelector.createContext)({});
exports.Context = Context;